module.exports = __webpack_public_path__ + "static/media/Group 24.455946d2.png";